module.exports = __webpack_public_path__ + "static/media/cafe-logo.65b80176.svg";